import DOMPurify from 'dompurify';

// Affiliate hosts whose anchors must carry rel="sponsored" (FTC + Google
// link-scheme compliance). Mirrors backend routes/prerender.py _AFFILIATE_HOSTS.
const AFFILIATE_HOSTS = [
  'americanpeptideresearch.net',
  'americanpeptideresearch.com',
  'ascensionpeptides.com',
  'tidd.ly',
  'awin1.com',
  'shop.centr.com',
  'biminihydrotherapy.com',
  'peptiq.io',
];

// Global hook: normalize rel on every sanitized anchor — new-tab links get
// noopener/noreferrer, affiliate links additionally get sponsored.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName !== 'A') return;
  const href = (node.getAttribute('href') || '').toLowerCase();
  const rel = new Set((node.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
  if (node.getAttribute('target') === '_blank') {
    rel.add('noopener');
    rel.add('noreferrer');
  }
  if (AFFILIATE_HOSTS.some((h) => href.includes(h))) {
    rel.add('sponsored');
  }
  if (rel.size) node.setAttribute('rel', [...rel].join(' '));
});

// Sanitize admin-authored rich HTML (articles, product descriptions) as
// defense-in-depth. Strips <script>, event handlers (onerror/onclick) and
// javascript: URLs while preserving the styling/markup the content relies on
// (<style> blocks, inline styles, target/rel on links, tables, figures, data-*).
export function sanitizeHtml(html) {
  if (!html || typeof html !== 'string') return '';
  return DOMPurify.sanitize(html, {
    ADD_TAGS: ['style', 'iframe'],
    ADD_ATTR: ['target', 'loading', 'decoding', 'allow', 'allowfullscreen', 'frameborder', 'referrerpolicy', 'fetchpriority', 'autoplay', 'muted', 'loop', 'playsinline', 'poster', 'preload', 'controls'],
    ALLOW_DATA_ATTR: true,
    // Content starts with a leading <style> block; without FORCE_BODY the HTML
    // parser hoists it into <head> and DOMPurify drops it (returns body only).
    FORCE_BODY: true,
  });
}
